import React, { useState } from 'react';
import './home.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as API from "../../Endpoints/endpoint"
import museum from '../Home/museum.png';

function Home() {
  const [formData, setFormData] = useState({ name: '', phone: '', email: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);  // New error state
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation check
    if (!formData.name || !formData.phone || !formData.email) {
      setError(true);  // show error message
      return;
    }

    setLoading(true);
    setError(false); // clear error if form is valid

    try {
      const response = await axios.post(API.POST_MEMBER_API, formData);

      if (response.data.exists) {
        navigate('/zones');
      } else {
        navigate('/zones');
      }
    } catch (err) {
      console.error('Error submitting form:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="homepage-container" style={{ backgroundImage: `url(${museum})` }}>
      <div className="homepage-content">
        <h1 className="homepage-title">Welcome to AI Kalki Museum</h1>

        <p className={`homepage-subtitle ${error ? 'error-text' : ''}`}>
          Please fill the details to explore it
        </p>

        <form className="homepage-form" onSubmit={handleSubmit}>
          <textarea className="form-input" placeholder="Name" onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
          <textarea className="form-input" placeholder="Phone" onChange={(e) => setFormData({ ...formData, phone: e.target.value })} />
          <textarea className="form-input" placeholder="Email" onChange={(e) => setFormData({ ...formData, email: e.target.value })} />

          <button
            className="get-started-button"
            type="submit"
            disabled={loading}
          >
            {loading ? 'Please wait...' : 'Get Started'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Home;
